import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import arrowNxt from "../../assets/icons/chevronsRight.svg"
import arrowPre from "../../assets/icons/chevronsLeft.svg"
import { dataCarousel } from "../Data/dataCarousel";

const CustomCarousel = () => {
    // Vars
    let startIndex = 2;
    let shiftAmt = 120;
    let isClickCooldown = false;
    let numEntries = dataCarousel.length;

    let images = createImageArrayForInfiniteLoop();

    // useStates
    const [showGif, setShowGif] = useState(false);
    const [activeIndex, setActiveIndex] = useState(startIndex);

    // useRefs
    const productContainerRef = useRef(null);
    const swiperRef = useRef(null)
    const shouldWaitRef = useRef(false);    // mutex for throttle

    const navigate = useNavigate();

    /**
     * Creates an image array based on the images stored in dataCarousel. The size of this array is 3n, where n is the number of images.
     * This is to give sufficient room visually to loop infinitely.
     * 
     * @returns {Array} Image array
     */
    function createImageArrayForInfiniteLoop() {
        let i;
        let images = [];
        let results;

        // Create array with images stored in dataCarousel
        for (i = 0; i < dataCarousel.length; i++) {
            images.push(dataCarousel[i].image);
        }

        // Triple copy the array
        results = [...images, ...images, ...images];

        return results;
    }

    /**
     * Set initial thumbnail image slider position to startIndex != 0 to allow for smooth previous transitions
     * and start playing video once in view.
     */
    useEffect(() => {
        const container = productContainerRef.current;
        if (container) {
            container.scrollLeft = shiftAmt * startIndex; // index 2
        }

        // Add Observer to only make video start playing once the active-image is in view
        const observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                // Run logic here
                setTimeout(() => {
                    setShowGif(true);
                }, 1000);
              }
            },
            {
              threshold: 0.5, // Trigger when 50% of the element is visible
            }
        );

        if (container) {
            observer.observe(container);
          }
      
          return () => {
            if (container) {
              observer.unobserve(container);
            }
          };
    }, []);

    /**
     * Leading edge throttle function.
     * 
     * @param {function} callback 
     * @param {int} delay in ms 
     * @returns 
     */
    function throttle(callback, delay) {
        return (...args) => {
          if (!shouldWaitRef.current) {
            shouldWaitRef.current = true;
            callback(...args);

            setTimeout(() => {
              shouldWaitRef.current = false;
            }, delay);
          }
        };
      }

    /**
     * Wiggle elements in the direction passed by dir.
     * @param {String} dir 
     */
    function wiggle(dir) {
        let wiggleDir = dir == 'left' ? 'wiggleLeft' : 'wiggleRight';
        
        // Wiggle all product thumbnails with a cascading delay
        const thumbs = document.querySelectorAll('.product-card');

        // Wiggle each thumbnail in cascading fashion
        for (let i = activeIndex; i < activeIndex + 6; i++) {
            setTimeout(() => {
                thumbs[i].classList.add(wiggleDir);
                thumbs[i].classList.add(wiggleDir);
                setTimeout(() => thumbs[i].classList.remove(wiggleDir), 400);
            }, i * 100);
        }

    }

    /**
     * Clones the current active thumb and animates the movement to the active-image location. Removes the clone when the animation is done.
     * Also wait a second before playing the GIF underneath the active-image.
     * 
     * @param {Integer} index 
     * @param {DOMElement} clickedImg 
     * @param {DOMElement} targetImg 
     */
    function clone(index, clickedImg, targetImg) {
        const clone = clickedImg.cloneNode(true);
        const thumbRect = clickedImg.getBoundingClientRect();
        const targetRect = targetImg.getBoundingClientRect();
        
        // Apply styles to clone
        clone.style.position = 'fixed';
        clone.style.top = `${thumbRect.top}px`;
        clone.style.left = `${thumbRect.left}px`;
        clone.style.width = `${thumbRect.width}px`;
        clone.style.height = `${thumbRect.height}px`;
        clone.style.transition = 'all 0.6s ease-in-out';
        clone.style.zIndex = '15';
        
        document.body.appendChild(clone);
        
        // Animate the clone to the active-image location
        requestAnimationFrame(() => {
            clone.style.top = `${targetRect.top}px`;
            clone.style.left = `${targetRect.left}px`;
            clone.style.width = `${targetRect.width}px`;
            clone.style.height = `${targetRect.height}px`;
        });
        
        // Remove the clone when the animatino is done
        clone.addEventListener('transitionend', () => {
            setShowGif(false);

            setTimeout(() => {
            if (document.body.contains(clone)) {
                document.body.removeChild(clone);
            }
            }, 500);
            
            // Update the active index
            setActiveIndex((index + 1) % numEntries);

            // Wait for a bit before showing the GIF under the active-image
            setTimeout(() => {
                setShowGif(true);
            }, 1000);
        });
    }

    /**
     * Shift slider by numPlaces amount. Deals with animations, colour changes, and content changes.
     * 
     * @param {DOMElement} item 
     * @param {Integer} numPlaces 
     */
    function shift (item, numPlaces) {
        let titless = document.querySelector('.project-title');
        let nextButton = document.querySelector('.nxt-btn');
        let prevButton = document.querySelector('.pre-btn');
        let details = document.querySelector('.details');
        let border = document.querySelectorAll('.product-image');
        let borderBottom = document.querySelectorAll('.border-bottom');
        let borderLeft = document.querySelectorAll('.border-left');
        let desc = document.querySelector('.project-description-text-slider')

        titless.innerHTML = dataCarousel[(activeIndex + numPlaces - 1) % numEntries].title
        desc.innerHTML = dataCarousel[(activeIndex + numPlaces - 1) % numEntries].description
        // Shift thumbnails
        item.scrollLeft += (shiftAmt * numPlaces);

        // Set colour of titles
        titless.style.color = dataCarousel[(activeIndex + numPlaces - 1) % numEntries].colour;

        // Set colour of next button
        nextButton.style.filter = dataCarousel[(activeIndex + numPlaces - 1) % numEntries].colourFilter;
        // Set colour of prev button
        prevButton.style.filter = dataCarousel[(activeIndex + numPlaces - 1) % numEntries].colourFilter;
        // Set colour of details button
        details.style.color = ('--details-color', dataCarousel[(activeIndex + numPlaces - 1) % numEntries]).colour;
        //Set colour of border
        border.forEach((b, i) => {
            b.style.setProperty('--border-color', dataCarousel[(activeIndex + numPlaces - 1) % numEntries].colour);
        })

        borderBottom.forEach((b, i) => {
            b.style.backgroundColor = dataCarousel[(activeIndex + numPlaces - 1) % numEntries].colour;
        })

        borderLeft.forEach((b, i) => {
            b.style.backgroundColor = dataCarousel[(activeIndex + numPlaces - 1) % numEntries].colour;
        })
    }

    /**
     * Reset the slider to index resetTo. Moves the slider to the index but does NOT show animation to give a seamless looking effect.
     * @param {DOMElement} item 
     * @param {Integer} resetTo 
     */
    function infiniteLoopReset(item, resetTo) {
        const container = document.getElementsByClassName('product-container')[0];
        setTimeout(() => {
            if (container) {
                container.classList.remove('smooth-scroll');
                item.scrollLeft = shiftAmt * resetTo;
                container.classList.add('smooth-scroll');
            }
        }, 1000);
    }
    
    /**
     * Handles the slider changes when clicking on a thumbnail to move.
     * 
     * @param {Integer} index 
     * @returns 
     */
    const handleImageClick = (index) => {
        const clickedImg = document.querySelectorAll('.product-thumb')[index];
        const targetImg = document.querySelector('.active-image');
        
        if (!clickedImg || !targetImg) return;

        // wiggle('left');

        clone(index, clickedImg, targetImg);
        
        const productContainers = document.querySelectorAll('.product-container');
        
        productContainers.forEach((item, i) => {
            // Shift elements visually
            let difference = index - activeIndex;
            shift(item, difference + 1)
        
            if (index >= numEntries - 1) {
                infiniteLoopReset(item, index - numEntries + 1);
            }
        });
    };

    /**
     * Handles the slider changes when clicking on the next button to move.
     * 
     * @returns 
     */
    const handleNext = () => {
        console.log(activeIndex)
        const clickedImg = document.querySelectorAll('.product-thumb')[activeIndex];
        const targetImg = document.querySelector('.active-image');
        
        if (!clickedImg || !targetImg) return;

        if (isClickCooldown) return;

        isClickCooldown = true;

        // Wiggle button
        const button = document.querySelector('.nxt-btn');
        if (button) {
            button.classList.add('wiggle');
            setTimeout(() => button.classList.remove('wiggle'), 400); // same as animation duration
        }

        // Wiggle the rest of the elements
        // wiggle('left');

        clone(activeIndex, clickedImg, targetImg);
        
        const productContainers = document.querySelectorAll('.product-container');
        
        productContainers.forEach((item, i) => {
            shift(item, 1);

            if (activeIndex >= numEntries - 1) {
                infiniteLoopReset(item, 0);
            }
        });
    }
    
    /**
     * Handles the slider changes when clicking on the prev button to move.
     * 
     * @returns 
     */
    const handlePrev = () => {
        const clickedImg = document.querySelectorAll('.product-thumb')[activeIndex];
        const targetImg = document.querySelector('.active-image');
        
        if (!clickedImg || !targetImg) return;
        
        const button = document.querySelector('.pre-btn');

        // Wiggle button
        if (button) {
            button.classList.add('wiggle');
            setTimeout(() => button.classList.remove('wiggle'), 400); // same as animation duration
        }

        // wiggle('right')

        setShowGif(false);

        setActiveIndex(activeIndex == 0 ? numEntries - 1 : activeIndex - 1);

        setTimeout(() => {
            setShowGif(true);
        }, 1000);
        
        // Change colours and content. Done in here because a little different from what the other handlers do.
        let titless = document.querySelector('.project-title');
        let desc = document.querySelector('.project-description-text-slider');
        let border = document.querySelectorAll('.product-image');
        let borderBottom = document.querySelectorAll('.border-bottom');
        let borderLeft = document.querySelectorAll('.border-left');

        titless.innerHTML = dataCarousel[(activeIndex + numEntries - 2) % numEntries].title;
        desc.innerHTML = dataCarousel[(activeIndex + numEntries - 2) % numEntries].description;

        // Set colour of titles
        titless.style.color = dataCarousel[(activeIndex + numEntries - 2) % numEntries].colour;

        //Set colour of border
        border.forEach((b, i) => {
            b.style.setProperty('--border-color', dataCarousel[(activeIndex + numEntries - 2) % numEntries].colour);
        })

        borderBottom.forEach((b, i) => {
            b.style.backgroundColor = dataCarousel[(activeIndex + numEntries - 2) % numEntries].colour;
        })

        borderLeft.forEach((b, i) => {
            b.style.backgroundColor = dataCarousel[(activeIndex + numEntries - 2) % numEntries].colour;
        })

        const productContainers = document.querySelectorAll('.product-container');

        productContainers.forEach((item, i) => {
            swiperRef.current?.slidePrev();
            item.scrollLeft -= shiftAmt;
            let nextButton = document.querySelector('.nxt-btn');
            let prevButton = document.querySelector('.pre-btn');
            nextButton.style.filter = dataCarousel[(activeIndex + numEntries - 2) % numEntries].colourFilter;
            prevButton.style.filter = dataCarousel[(activeIndex + numEntries - 2) % numEntries].colourFilter;
        
            if (activeIndex == 0) {
                infiniteLoopReset(item, numEntries - 1);
            } else if (activeIndex === 1) {
                infiniteLoopReset(item, numEntries);
            }
        });
    }

    // For leading edge throttling to limit the clicks on thumbs and buttons
    const handleImageClickThrottled = throttle((index) => handleImageClick(index), 1000);
    const debouncedNext = throttle(handleNext, 1000);
    const debouncedPrev = throttle(handlePrev, 1000);

    const navigateToProjects = () => {
        navigate("/projects");
    }

    return (
        <div>
            <div className="carousel-container-big">
                <div className="carousel-left">
                    <div className="image-container">
                        <img
                            src={images[(activeIndex + numEntries - 1) % numEntries]}
                            className={`active-image`}
                            alt={`active image for ${dataCarousel[(activeIndex + numEntries - 1) % numEntries].title} poster`}
                        />
                        <video
                            src={dataCarousel[(activeIndex + numEntries - 1) % numEntries].video}
                            className={`active-image ${showGif ? '' : 'hidden'}`}
                            autoPlay
                            muted
                            loop
                            playsInline
                        />
                    </div>
                </div>
                <div className="carousel-right">
                    <div className="text-swiper">
                        <div className="title-wrapper-text-slider">
                            <h3 className="project-title">{dataCarousel[startIndex - 1].title}</h3>
                            <p className="project-description-text-slider">{dataCarousel[startIndex - 1].description}</p>
                        </div>
                    </div>
                    <p className='details' onClick={navigateToProjects}>View More -{'>'}</p>
                    <section className="product"> 
                        <button className="pre-btn blue-overlay" onClick={debouncedPrev}>
                            <img src={arrowPre} alt="previous button" />
                        </button>
                        <div className="product-container smooth-scroll" ref={productContainerRef}>
                            {images.map((image, index) => {
                                return (
                                    <div className="product-card">
                                        <div className="product-image">
                                            <img
                                                key={index}
                                                src={image}
                                                alt={`poster thumbnail for ${dataCarousel[index % numEntries].title}`}
                                                onClick={() => handleImageClickThrottled(index)}
                                                className={`product-thumb`}
                                            />
                                            <span className="border-bottom"></span>
                                            <span className="border-left"></span>                                
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <button className="nxt-btn blue-overlay" onClick={debouncedNext}>
                            <img src={arrowNxt} alt="next button" />
                        </button>
                    </section>
                </div>
            </div>
      </div>
    );
  };
  
  export default CustomCarousel;